import React, { memo } from "react";
import { StyledDiv, StyledRing, StyledWrapper } from "./Spinner.elements";


export interface SpinnerProps {
  size?: 'small' | 'default';
}

export function Spinner(props: SpinnerProps) {
  const { size = 'default' } = props;

return (
    <StyledWrapper size={size}>
        <StyledRing size={size}>
            <StyledDiv size={size}></StyledDiv>
            <StyledDiv size={size}></StyledDiv>
            <StyledDiv size={size}></StyledDiv>
            <StyledDiv size={size}></StyledDiv>
        </StyledRing>
    </StyledWrapper>
)
};

export default memo(Spinner);
